import React, { useState } from 'react'
import {
  SimpleForm,
  required,
  Create,
  useNotify,
  useRedirect,
  SelectInput,
  Button,
} from 'react-admin'

import { Grid, Paper, Typography, makeStyles } from '@material-ui/core'
import { ResourceSelector } from 'components'

import { Tooltip } from 'components'

const useStyles = makeStyles({
  container: {
    width: '100%',
  },
  formContainer: {
    backgroundColor: '#F5F5F5',
  },
  paperContainer: {
    padding: 16,
  },
})

export const CreateForm = (props: any) => {
  const redirect = useRedirect()
  const notify = useNotify()
  const classes = useStyles()
  const {
    shouldRedirect = true,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
    toolbar = <></>,
    aside = <></>,
    ...rest
  } = props

  const [items, setItems] = useState([1])

  const onSuccess = () => {
    notify('post_successfully')
    if (shouldRedirect) redirect(props.basePath)
    onSubmitSuccess()
  }

  const onFailure = (error: any) => {
    onSubmitFailure(error)
    notify('post_failed', 'warning')
  }

  return (
    <Create
      aside={aside}
      {...rest}
      onSuccess={onSuccess}
      onFailure={onFailure}
      className={classes.container}
    >
      <SimpleForm
        warnWhenUnsavedChanges
        className={classes.formContainer}
        toolbar={toolbar}
      >
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={2}
          className={classes.container}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Paper className={classes.paperContainer}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography variant="h5" color="textSecondary" gutterBottom>
                  Vincular novos conteúdos
                </Typography>
                <hr />
              </Grid>

              <Grid container spacing={2} direction="column">
                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <Typography
                    variant="subtitle2"
                    color="textPrimary"
                  >{`Conteúdo que receberá o item vinculado: `}</Typography>
                  <Typography variant="caption" color="textSecondary">
                    {`Digite uma parte do nome do conteúdo para o qual você deseja vincular.`}
                  </Typography>
                  <Tooltip title={'weeks.id'}>
                    <ResourceSelector
                      fullWidth
                      label="Curso/Série/Aula"
                      resource={['cms/grouper/courses', 'cms/grouper/lesson']}
                      source="grouper_id"
                      optionValue="id"
                      validate={[required('Obrigatório')]}
                    />
                  </Tooltip>
                </Grid>
              </Grid>

              {items.map((item, index) => {
                return (
                  <Grid container spacing={2} direction="row">
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                      <Typography
                        variant="subtitle2"
                        color="textPrimary"
                      >{`Conteúdo a ser vinculado: `}</Typography>
                      <Typography variant="caption" color="textSecondary">
                        {`Digite uma parte do nome do conteúdo que você deseja vincular.`}
                      </Typography>
                      <Tooltip title={'weeks.id'}>
                        <ResourceSelector
                          fullWidth
                          label="Conteúdo"
                          resource={[
                            'cms/content/images',
                            'cms/content/videos',
                            'cms/content/attachments',
                            'cms/content/tags',
                            'cms/content/stylesheets',
                            'cms/content/involved_people',
                            'cms/content/marks',
                            'cms/content/quiz_options',
                            'cms/content/comments_titles',
                          ]}
                          source={`contents[${index}].object_id`}
                          optionValue="id"
                          validate={[required('Obrigatório')]}
                        />
                      </Tooltip>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Typography
                        variant="subtitle2"
                        color="textPrimary"
                      >{`Tipo de conteúdo a ser vinculado:`}</Typography>
                      <Typography variant="caption" color="textSecondary">
                        {`Selecione o tipo de conteúdo a que será vinculado`}
                      </Typography>
                      <Tooltip title={'weeks.id'}>
                        <SelectInput
                          fullWidth
                          label="Tipo"
                          source={`contents[${index}].object_type`}
                          choices={[
                            { id: 'stylesheets', name: 'Tema' },
                            { id: 'videos', name: 'Vídeo' },
                            { id: 'involved_people', name: 'Pessoa' },
                            { id: 'images', name: 'Banner' },
                            { id: 'marks', name: 'Marcador' },
                            { id: 'attachments', name: 'Material' },
                            {
                              id: 'comments_titles',
                              name: 'Pergunta de comentário',
                            },
                            { id: 'tags', name: 'Tag' },
                          ]}
                        />
                      </Tooltip>
                    </Grid>
                  </Grid>
                )
              })}
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => setItems([...items, items.length + 1])}
                  label="Vincular mais itens"
                />
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  )
}
